import {Dropdown, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import React from 'react';
import classNames from 'classnames';
import styles from '../../../components/Common/FieldSearch/components/SearchOptionsV2/SearchOptions.module.scss';

export const OptionsHeader = ({title1, title2, sortBy, isDesc, handleSortByChange}) => {
    return (
        <div className="search-header-container">
            <React.Fragment>
                {title1 && (
                    <Dropdown.Header
                        title={`${title1}`}
                        onClick={() => handleSortByChange('string1')}
                        icon={
                            sortBy === 'string1' ? (
                                <Icon
                                    icon={PriorityIcon.sorted}
                                    componentClasses={classNames(styles.sortIcon, {
                                        [styles.desc]: isDesc
                                    })}
                                />
                            ) : null
                        }
                    />
                )}
                {title2 && (
                    <Dropdown.Header
                        title={`${title2}`}
                        onClick={() => handleSortByChange('string2')}
                        icon={
                            sortBy === 'string2' ? (
                                <Icon
                                    icon={PriorityIcon.sorted}
                                    componentClasses={classNames(styles.sortIcon, {
                                        [styles.desc]: isDesc
                                    })}
                                />
                            ) : null
                        }
                    />
                )}
            </React.Fragment>
        </div>
    );
};
